// extracted by mini-css-extract-plugin
export default {"building_name":"RackTableHeader_building_name__-8wtq"};